<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="9"
        align-self="center"
      >
        <div class="primary--text text-h5 my-2">
          {{ $t('employee_seminar_info.title') }}
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
        align-self="center"
      >
        <v-text-field
          v-if="tab===0"
          v-model="qualityCompanySearch"
          outlined
          dense
          :placeholder="$t('common.search')"
          hide-details
          class="elevation-1"
          @change="getEmployeeSeminarQualityCompany"
        />
        <v-text-field
          v-if="tab===1"
          v-model="search"
          outlined
          dense
          :placeholder="$t('common.search')"
          hide-details
          class="elevation-1"
          @change="getEmployeeSeminarInfo"
        />
      </v-col>
      <v-col cols="12">
        <v-container class="rounded-sm pa-0 mt-2 pb-1">
          <template>
            <v-tabs
              v-model="tab"
              center-active
              :fixed-tabs="isMobileView"
            >
              <v-tab
                v-for="(item, index) in tabs"
                :key="index"
                :class="['custom-tab', isMobileView && index === 0 ? 'mobile-first-tab' : '', tab === index ? 'active-tab' : '']"
              >
                {{ item.name }}
              </v-tab>
            </v-tabs>
          </template>
        </v-container>
        <v-tabs-items
          v-model="tab"
          class="elevation-2"
        >
          <v-tab-item>
            <v-data-table
              fixed-header
              class="elevation-2"
              :headers="headersSortedQualityCompany"
              :items="tableQualityCompanyData"
              :loading="seminarQCLoading"
              :sort-by.sync="tableQualityCompanyOption.sortBy"
              :sort-desc.sync="tableQualityCompanyOption.sortDesc"
              :items-per-page.sync="tableQualityCompanyOption.itemsPerPage"
              :page.sync="tableQualityCompanyOption.page"
              :server-items-length="tableQualityCompanyTotalItems"
              :footer-props="{
                'items-per-page-options': [5, 10, 25, 50],
                'items-per-page-text': $t('employee_seminar_info.pagination_text')
              }"
            >
              <template
                v-if="$vuetify.breakpoint.mdAndUp"
                #item="i"
              >
                <tr>
                  <td
                    v-for="(column, index) in headersSortedQualityCompany"
                    :key="`column-${index}`"
                    :class="column.value === 'name' || 'name_kana' ? 'font-weight-bold' : 'text-center'"
                  >
                    <template v-if="column.value === 'name'">
                      <span
                        class="link-like-text"
                        @click="detailCustomer(i.item.customer_id)"
                      >
                        {{ i.item[column.value] }}
                      </span>
                    </template>
                    <template v-else-if="column.value === 'name_kana'">
                      <span>{{ i.item[column.value] }}</span>
                    </template>
                    <template v-else>
                      <v-row>
                        <v-col
                          cols="3"
                          class="d-flex justify-center align-center custom-table-border"
                        >
                          <span
                            v-if="i.item[column.value].attend_count !== null"
                            class="font-weight-bold"
                          >
                            {{ i.item[column.value].attend_count }}
                          </span>
                          <span v-else> - </span>
                        </v-col>
                        <v-col
                          class="d-flex justify-center align-center"
                          cols="9"
                          :class="seminarIsNotPast(i.item[column.value].end) ? 'red--text' : ''"
                        >
                          <span>
                            {{ i.item[column.value].display !== null ? i.item[column.value].display : '-' }}
                          </span>
                        </v-col>
                      </v-row>
                    </template>
                  </td>
                </tr>
              </template>
              <template
                v-for="(column, index) in headersSortedQualityCompany"
                v-else
                #[`item.${column.value}`]="{item}"
              >
                <span
                  v-if="item[column.value]"
                  :key="`column-${index}`"
                  @click="detailCustomer(item.customer_id)"
                >
                  <span v-if="column.value === 'name' || column.value === 'name_kana'">
                    {{ item[column.value] }}
                  </span>
                  <span
                    v-else
                  >
                    <span
                      v-if="item[column.value].attend_count !== null && item[column.value].attend_count !== 0"
                      :class="seminarIsNotPast(item[column.value].end) ? 'red--text' : ''"
                    >
                      ({{ item[column.value].attend_count }}) {{ item[column.value].display || '-' }}
                    </span>
                    <span
                      v-else
                      :class="seminarIsNotPast(item[column.value].end) ? 'red--text' : ''"
                    >
                      {{ item[column.value].display || '-' }}
                    </span>
                  </span>
                </span>
              </template>
              <template #footer.page-text>
                <span>{{ tableQualityCompanyOption.page }} / {{ seminarQCTotalPages }}</span>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              fixed-header
              class="elevation-2"
              :headers="headers"
              :loading="seminarRTTLoading"
              :items="seminarInfo"
              :sort-by.sync="option.sortBy"
              :sort-desc.sync="option.sortDesc"
              :items-per-page.sync="option.itemsPerPage"
              :page.sync="option.page"
              :server-items-length="totalItems"
              :footer-props="{
                'items-per-page-options': [5, 10, 25, 50],
                'items-per-page-text': $t('employee_seminar_info.pagination_text')
              }"
            >
              <template
                v-if="$vuetify.breakpoint.mdAndUp"
                #item="i"
              >
                <tr>
                  <td
                    v-for="(column, index) in headers"
                    :key="`column-${index}`"
                    :class="column.value === 'name' || 'name_kana' ? 'font-weight-bold' : 'text-center'"
                  >
                    <span
                      v-if="i.item[column.value]"
                    >
                      <span
                        v-if="i.item[column.value].start"
                        :class="seminarIsNotPast(i.item[column.value].end) ? 'red--text' : ''"
                      >
                        <span v-if="column.value === 're_atc'">
                          <v-row>
                            <v-col
                              cols="3"
                              class="d-flex justify-center align-center custom-table-border"
                            >
                              <span
                                v-if="i.item[column.value].attend_count && i.item[column.value].attend_count !== 0"
                                class="font-weight-bold"
                              >
                                {{ i.item[column.value].attend_count }}
                              </span>
                              <span v-else>-</span>
                            </v-col>
                            <v-col
                              class="d-flex justify-center align-center"
                              cols="9"
                            >
                              <span>
                                {{ i.item[column.value].display }}
                                <span
                                  v-if="i.item[column.value].pre_questions"
                                  class="link-button"
                                  @click="courseReportRedirect(i.item[column.value].contents, 0)"
                                ><br>{{ $t("common.pre_course_report") }}</span>
                                <span
                                  v-if="i.item[column.value].post_questions"
                                  class="link-button"
                                  @click="courseReportRedirect(i.item[column.value].contents, 1)"
                                ><br>{{ $t("common.post_course_report") }}</span>
                              </span>
                            </v-col>
                          </v-row>
                        </span>
                        <span v-else>
                          {{ i.item[column.value].display }}
                          <span
                            v-if="i.item[column.value].pre_questions"
                            class="link-button"
                            @click="courseReportRedirect(i.item[column.value].contents, 0)"
                          ><br>{{ $t("common.pre_course_report") }}</span>
                          <span
                            v-if="i.item[column.value].post_questions"
                            class="link-button"
                            @click="courseReportRedirect(i.item[column.value].contents, 1)"
                          ><br>{{ $t("common.post_course_report") }}</span>
                        </span>
                      </span>
                      <span
                        v-else-if="column.value === 'name'"
                        class="link-like-text"
                        @click="detailCustomer(i.item.customer_id)"
                      >
                        {{ i.item[column.value] }}
                      </span>
                      <span v-else-if="column.value === 'name_kana'">
                        {{ i.item[column.value] }}
                      </span>
                      <span v-else>
                        <span v-if="column.value === 're_atc'">
                          <v-row>
                            <v-col
                              cols="3"
                              class="d-flex justify-center align-center custom-table-border"
                            >
                              <span>-</span>
                            </v-col>
                            <v-col
                              class="d-flex justify-center align-center"
                              cols="9"
                            >
                              <span>-</span>
                            </v-col>
                          </v-row>
                        </span>
                        <span v-else>
                          -
                        </span>
                      </span>
                    </span>
                    <span v-else>
                      -
                    </span>
                  </td>
                </tr>
              </template>
              <template
                v-for="(column, index) in headers"
                v-else
                #[`item.${column.value}`]="{item}"
              >
                <span
                  v-if="item[column.value]"
                  :key="`column-${index}`"
                  @click="detailCustomer(item.customer_id)"
                >
                  <span
                    v-if="item[column.value].start"
                    :class="seminarIsNotPast(item[column.value].end) ? 'red--text' : ''"
                  >
                    <span v-if="column.value === 're_atc'">
                      <span v-if="item[column.value].attend_count && item[column.value].attend_count !== 0">
                        ({{ item[column.value].attend_count }}) {{ item[column.value].display }}
                      </span>
                      <span v-else>{{ item[column.value].display }}</span>
                    </span>
                    <span v-else>
                      {{ item[column.value].display }}
                      <!--Todo: added function to open questionnaire page after ready-->
                      <span
                        v-if="item[column.value].pre_questions"
                        class="link-button"
                        @click="courseReportRedirect(item[column.value].contents, 0)"
                      ><br>{{ $t("common.pre_course_report") }}</span>
                      <span
                        v-if="item[column.value].post_questions"
                        class="link-button"
                        @click="courseReportRedirect(item[column.value].contents, 1)"
                      ><br>{{ $t("common.post_course_report") }}</span>
                    </span>
                  </span>
                  <span v-else-if="column.value === 'name'">
                    {{ item[column.value] }}
                  </span>
                  <span v-else-if="column.value === 'name_kana'">
                    {{ item[column.value] }}
                  </span>
                  <span v-else>
                    -
                  </span>
                </span>
                <span
                  v-else
                  :key="`column-${index}`"
                >
                  -
                </span>
              </template>
              <template #footer.page-text>
                <span>{{ option.page }} / {{ seminarRTTTotalPages }}</span>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col
        v-if="!(seminarQCLoading || seminarRTTLoading)"
        cols="12"
      >
        <div
          style="white-space: pre-line; font-size: small;"
          v-text="$t('employee_seminar_info.note')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QUATSError from '../../../plugins/error'

export default {
  name: 'EmployeeSeminarInfo',
  data() {
    return {
      search: '',
      totalItems: 0,
      option: {
        itemsPerPage: 10,
        page: 1,
        sortBy: 'name_kana',
        sortDesc: false,
      },
      qualityCompanySearch: '',
      tableQualityCompanyOption: {
        itemsPerPage: 10,
        page: 1,
        sortBy: 'name_kana',
        sortDesc: false,
      },
      tableQualityCompanyTotalItems: 0,
      seminarInfo: [],
      error: null,
      tab: null,
      tableQualityCompanyData: [],
      seminarQCLoading: false,
      seminarQCTotalPages: 1,
      seminarRTTLoading: false,
      seminarRTTTotalPages: 1,
      tableQualityCompanySortedHeaders: []
    }
  },
  computed: {
    /***
     * @desc search params on the table as pagination arguments
     * @returns []
     */
    headers() {
      return [
        { text: this.$t('employee_seminar_info.name'), align: 'start', value: 'name', width: '175px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.name_kana'), align: 'start', value: 'name_kana', width: '175px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.atc'), align: 'center', value: 'atc', sortable: false, width: '150px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.dc'), align: 'center', value: 'dc', sortable: false, width: '150px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.dac'), align: 'center', value: 'dac', sortable: false, width: '150px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.ppc'), align: 'center', value: 'ppc', sortable: false, width: '150px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.re_atc'), align: 'center', value: 're_atc', sortable: false, width: '150px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.ptp'), align: 'center', value: 'ptp', sortable: false, width: '200px', class: 'primary white--text py-2' },
      ]
      // let extraHeaders = []
      // this.seminarInfo.forEach(employee => {
      //   Object.keys(employee).forEach(x => {
      //     if (x.includes('atc_re')) {
      //       if (!extraHeaders.includes(x)) {
      //         extraHeaders.push(x)
      //       }
      //     }
      //   })
      // })
      // extraHeaders.forEach(header => {
      //   tableHeaders.push({ text: this.$t('employee_seminar_info.atc_re', {num: header.slice(6)}), align: 'center', value: header, sortable: false, width: '150px', class: 'primary white--text pa-2' })
      // })
    },
    searchParams() {
      let requestParam = `?page_size=${this.option.itemsPerPage}&page=${this.option.page}&disclosure_level=2`
      if (this.search) {
        requestParam += `&search=${this.search}`
      }
      if (this.option.sortBy) {
        requestParam += `&sort_by=${this.option.sortBy}`
      }
      if (this.option.sortDesc) {
        requestParam += `&sort_desc=${this.option.sortDesc}`
      }
      return requestParam
    },
    searchQualityCompanyParams() {
      let requestParam = `?page_size=${this.tableQualityCompanyOption.itemsPerPage}&page=${this.tableQualityCompanyOption.page}&disclosure_level=1`
      if (this.qualityCompanySearch) {
        requestParam += `&search=${this.qualityCompanySearch}`
      }
      if (this.tableQualityCompanyOption.sortBy) {
        requestParam += `&sort_by=${this.tableQualityCompanyOption.sortBy}`
      }
      if (this.tableQualityCompanyOption.sortDesc) {
        requestParam += `&sort_desc=${this.tableQualityCompanyOption.sortDesc}`
      }
      return requestParam
    },
    tabs() {
      return [
        { name: this.$t('employee_seminar_info.tab_quality_company'), id: 1 },
        { name: this.$t('employee_seminar_info.tab_road_top'), id: 2 }
      ]
    },
    headersSortedQualityCompany() {
      const tableHeaders = [
        { text: this.$t('employee_seminar_info.name'), align: 'start', value: 'name', width: '175px', class: 'primary white--text py-2' },
        { text: this.$t('employee_seminar_info.name_kana'), align: 'start', value: 'name_kana', width: '175px', class: 'primary white--text py-2' },
      ]
      this.tableQualityCompanySortedHeaders.forEach(header => {
        tableHeaders.push({ text: header.display_name, align: 'center', value: 'seminar_'.concat(header.id), sortable: false, width: '160px', class: 'primary white--text py-2' })
      })
      return tableHeaders
    },
    isMobileView() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    option: {
      deep: true,
      handler() {
        this.getEmployeeSeminarInfo()
      }
    },
    tableQualityCompanyOption: {
      deep: true,
      handler() {
        this.getEmployeeSeminarQualityCompany()
      }
    }
  },
  created() {
    if(this.$store.state.account.user) {
      this.getEmployeeAllSeminarLevels()
    }
  },
  methods: {
    courseReportRedirect(data, flg) {
      const questionnaire = data.find(x => x.fc_flg === flg)
      this.$router.push({ name: 'CourseReportDetail', params: { seminar_id: questionnaire.seminar_id, customer_id: questionnaire.id, fc_flg: questionnaire.fc_flg }})
    },

    getEmployeeAllSeminarLevels() {
      this.seminarQCLoading = true
      this.seminarRTTLoading = true

      const promises = [
        window.axios.get('/api/employee-seminar-info/seminar/display-order'),
        window.axios.get(`/api/employee-seminar-info/seminar-detail${this.searchQualityCompanyParams}`),
        window.axios.get(`/api/employee-seminar-info/seminar-detail${this.searchParams}`)
      ]

      return Promise.all(promises)
        .then(results => {

          const seminarOrderResult = results[0].data.data
          const seminarLevelOneResult = results[1].data.data.data

          this.arrangeQualityCompanyData(seminarOrderResult.data, seminarLevelOneResult.data)
          this.tableQualityCompanyTotalItems = seminarLevelOneResult.total
          this.seminarQCTotalPages = seminarLevelOneResult.last_page

          const seminarLevelTwoResult = results[2].data.data.data
          this.arrangeSeminarInfo(seminarLevelTwoResult.data)
          this.totalItems = seminarLevelTwoResult.total
          this.seminarRTTTotalPages = seminarLevelTwoResult.last_page
        }).catch(err => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
          this.seminarQCLoading = false
          this.seminarRTTLoading = false
        })
    },
    getEmployeeSeminarInfo() {
      this.seminarRTTLoading = true
      const promises = [
        window.axios.get(`/api/employee-seminar-info/seminar-detail${this.searchParams}`),
      ]
      return Promise.all(promises)
        .then(results => {
          const pagedResults = results[0].data.data.data
          this.arrangeSeminarInfo(pagedResults.data)
          this.totalItems = pagedResults.total
          this.seminarRTTTotalPages = pagedResults.last_page
        }).catch(err => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
          this.seminarRTTLoading = false
        })
    },
    arrangeSeminarInfo(employees) {
      // Todo: need to improve to accept dynamic seminar value without edit the code
      this.seminarInfo = employees.map(employee => {
        const data = {
          name: this.getModifiedName(employee),
          name_kana: employee.name_kana,
          atc: {
            start: '',
            end: '',
            contents: '',
          },
          dc: {
            start: '',
            end: '',
            contents: ''
          },
          dac: {
            start: '',
            end: '',
            contents: ''
          },
          ppc: {
            start: '',
            end: '',
            contents: ''
          },
          ptp: {
            start: '',
            end: '',
            contents: ''
          },
          re_atc: {
            start: '',
            end: '',
            contents: '',
            attend_count: 0
          }
        }
        data['customer_id'] = employee.customer_id
        employee.seminar_enrollments.forEach(seminar => {
          const getSeminarName = (seminar_division_id) => {
            switch (seminar_division_id) {
            case 1:
              return 'atc'
            case 2:
              return 'dc'
            case 3:
              return 'dac'
            case 4:
              return 'ppc'
            case 15:
              return 'ptp'
            case 're_atc':
              return 're_atc'
            default:
              return ''
            }
          }
          const seminarName = getSeminarName(seminar.seminar_division_id)
          data[seminarName]['start'] = seminar.start_date
          data[seminarName]['end'] = seminar.end_date
          data[seminarName]['display'] = this.seminarDateRangeDisplay(seminar.start_date, seminar.end_date)
          data[seminarName]['contents'] = seminar.questionnaire_contents
          data[seminarName]['pre_questions'] = seminar.questionnaire_contents?.length > 0 && seminar.questionnaire_contents?.find(el => el.fc_flg === 0)
          data[seminarName]['post_questions'] = seminar.questionnaire_contents?.length > 0 && seminar.questionnaire_contents?.find(el => el.fc_flg === 1)
          if (seminarName === 're_atc') {
            data['re_atc']['attend_count'] = seminar.attend_count ?? 0
          }
        })
        return data
      })
      this.seminarRTTLoading = false
    },
    getEmployeeSeminarQualityCompany() {
      this.seminarQCLoading = true
      const promises = [
        window.axios.get('/api/employee-seminar-info/seminar/display-order'),
        window.axios.get(`/api/employee-seminar-info/seminar-detail${this.searchQualityCompanyParams}`),
      ]
      return Promise.all(promises)
        .then(results => {
          const seminarOrderResult = results[0].data.data
          const seminarLevelOneResult = results[1].data.data.data
          this.arrangeQualityCompanyData(seminarOrderResult.data, seminarLevelOneResult.data)
          this.tableQualityCompanyTotalItems = seminarLevelOneResult.total
          this.seminarQCTotalPages = seminarLevelOneResult.last_page
        }).catch(err => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
          this.seminarQCLoading = false
        })
    },
    arrangeQualityCompanyData(seminarHeaders, employees) {
      let arrangeData = []
      this.tableQualityCompanySortedHeaders = this.arrangeSeminarsOrder(seminarHeaders)

      employees.forEach(employee => {
        let data = {
          customer_id: '',
          name: this.getModifiedName(employee),
          name_kana: employee.name_kana
        }
        data['customer_id'] = employee.customer_id

        this.tableQualityCompanySortedHeaders.forEach(header => {
          const matchingEnrollment = employee.seminar_enrollments.find(enrollment => {
            return enrollment.seminar_division_id === header.id
          })

          if (matchingEnrollment) {
            data['seminar_' + header.id] = {
              start: matchingEnrollment.start_date,
              end: matchingEnrollment.end_date,
              display: this.seminarDateRangeDisplay(matchingEnrollment.start_date, matchingEnrollment.end_date),
              attend_count: matchingEnrollment.attend_count
            }
          } else {
            data['seminar_' + header.id] = {
              start: null,
              end: null,
              date: null,
              attend_count: null
            }
          }
        })
        arrangeData.push(data)
      })
      this.seminarQCLoading = false
      this.tableQualityCompanyData = arrangeData
    },
    arrangeSeminarsOrder(seminars) {
      return seminars.sort((a, b) => a.display_order - b.display_order)
    },
    getModifiedName(employee) {
      let modifiedName = employee.name
      if (employee.pro_speaker_rank) {
        const rank = employee.pro_speaker_rank
        if (rank === 20) {
          modifiedName += ' (APS)'
        } else if (rank === 30) {
          modifiedName += ' (BPS)'
        } else if (rank === 40) {
          modifiedName += ' (SPS)'
        } else if (rank === 50) {
          modifiedName += ' (EPS)'
        } else if (rank === 60) {
          modifiedName += ' (MPS)'
        }
      }
      return modifiedName
    },
    seminarIsNotPast(date) {
      let endDate = new Date(date)
      endDate.setHours(23,59,59)
      const endTimestamp = Math.floor(endDate.getTime() / 1000)
      const currentTimestamp = Math.floor(new Date().getTime() / 1000)
      return currentTimestamp <= endTimestamp
    },
    seminarDateRangeDisplay(startDate, endDate) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      if (!endDate || start.toString() === end.toString()) {
        return startDate.replace(/-/g, '/')
      } else if (start.getMonth() === end.getMonth()) {
        return `${startDate.replace(/-/g, '/')} ~ ${end.getDate().toString().padStart(2, '0')}`
      } else {
        return `${startDate.replace(/-/g, '/')} ~ ${endDate.replace(/-/g, '/')}`
      }
    },
    detailCustomer(id) {
      this.$router.push({name: 'EmployeeSeminarInfoDetail', params: {id: id.toString()}})
    }
  }
}
</script>

<style scoped>
::v-deep table > tbody > tr > td:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 4;
  background: white;
}
::v-deep table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 4;
  background: white;
}
::v-deep table > thead > tr > th:nth-child(1) {
  z-index: 5 !important;
}
::v-deep .theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: white !important;
}
th:not(:last-child), td:not(:last-child) {
  border-right: 1px solid #e0e0e0;
}
::v-deep .v-data-table__mobile-row__header {
  width: 50%;
  padding-bottom: 8px;
  padding-top: 8px;
}
::v-deep .v-data-table__mobile-row__cell {
  width: 50%;
}
.link-like-text {
  cursor: pointer;
}
::v-deep .v-slide-group__prev {
  display: none !important;
}

.custom-tab {
  border: 1px solid #ccc;
  border-radius: 6px 6px 0 0;
  padding: 10px 20px;
  cursor: pointer;
  margin-right: 8px;
  transition: background-color 0.3s, color 0.3s;
}

.active-tab {
  border: 1px solid #072a67;
  background-color: #072a67;
  color: white;
}

::v-deep .v-tabs-slider-wrapper {
  display: none !important;
}

.custom-table-border {
  border-right: 1px solid #E0E0E04C;
}

.mobile-first-tab {
  font-size: 13px;
}

.link-button {
  color: #4444ea;
  cursor: pointer;
  text-decoration: underline;
}
</style>
